import { Badge } from '@/components/ui/badge';
import {
  CoachSessionRemarkV2,
  CoachSessionRemarkV2Completed,
  formatCoachSessionRemarkV2Label,
  SessionCompletionStatus,
  SessionZoom,
} from '@airreading/common/data';
import { Temporal } from 'temporal-polyfill';
export interface SessionCompletionStatusCellProps {
  status: SessionCompletionStatus;
  coachSessionRemarksV2?: CoachSessionRemarkV2[];
  session?: {
    zoom?: SessionZoom | null;
    startInstant?: Temporal.Instant;
    endInstant?: Temporal.Instant;
    addedCoachSessionRemarksV2?: CoachSessionRemarkV2[];
  };
}

export function SessionCompletionStatusCell({
  status,
  coachSessionRemarksV2,
  session,
}: SessionCompletionStatusCellProps) {
  if (status === SessionCompletionStatus['In Progress']) {
    return <span className="text-muted-foreground">—</span>;
  }

  const isIncomplete = status === SessionCompletionStatus['Incomplete'];

  if (isIncomplete) {
    return (
      <div className="flex items-center gap-2">
        <span className="flex flex-row gap-1 items-center">
          {coachSessionRemarksV2
            ?.filter((tag) => !CoachSessionRemarkV2Completed.includes(tag))
            ?.map((tag) => (
              <Badge key={tag} variant="outline" className="text-center">
                {formatCoachSessionRemarkV2Label(tag, session)}
              </Badge>
            ))}
        </span>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2">
      {status === SessionCompletionStatus['Completed'] && '✅ Completed'}
      <span className="flex flex-row gap-1 items-center">
        {coachSessionRemarksV2
          ?.filter((tag) => CoachSessionRemarkV2Completed.includes(tag))
          .map((tag) => (
            <Badge key={tag} variant="outline" className="text-center">
              {formatCoachSessionRemarkV2Label(tag, session)}
            </Badge>
          ))}
      </span>
    </div>
  );
}
